import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import CommentThread from "./CommentThread";

// Card wrapper around CommentThread so comment sections look identical
// across detail pages (work orders, delivery notes).
function CommentCard({ comments, canManageComment, onAdd, onUpdate, onDelete }) {
  const { t } = useTranslation();

  return (
    <div className="card border-0 mb-4">
      <div className="card-header h6 mb-0 bg-none p-3">
        <i className="fa fa-comments fa-lg fa-fw text-dark text-opacity-50 me-1" />
        {t("menu.comments")}
      </div>
      <div className="card-body">
        <CommentThread
          comments={comments}
          canManageComment={canManageComment}
          onAdd={onAdd}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
}

CommentCard.propTypes = {
  comments: PropTypes.array,
  canManageComment: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
};

export default CommentCard;
